import Vue from 'vue'

export default new class {

    error(msg) {
        return Vue.toasted.error(msg, {
            theme: "bubble",
            position: "bottom-center",
            duration : 5000,
            iconPack: 'fontawesome',
            icon: 'times',
            type: 'error',
            singleton: true
        })
    }


    success(msg) {
        return Vue.toasted.success(msg, {
            theme: "bubble",
            position: "bottom-center",
            duration : 5000,
            iconPack: 'fontawesome',
            icon: 'check',
            type: 'success',
            singleton: true
        })
    }



}